export * from './edit-deceased-details-view';
export * from './edit-doctor-induna-view';
export * from './edit-form-info-details';
export * from './edit-funeral-parlour-view';
export * from './edit-informant-view';
